import logger, { enableLog, disableLog, setLogContext } from '@/logger'

const _getters = {
  logConfig: (_, __, ___, rootGetters) => {
    const variant = rootGetters['featureToggles/getVariant']('AHA-35479-setup-logging-lib')
    if (variant?.payload?.type === 'json') {
      return JSON.parse(variant.payload.value)
    }
    return undefined
  },
  canTrackSlideIdForPostReqs: (_, __, ___, rootGetters) => {
    return rootGetters['featureToggles/isFeatureEnabled']('AHA-40581-track-answer-slideid')
  },
}

const plugin =
  (store) => {
    store.subscribe((mutation) => {
      if (mutation.type === 'featureToggles/setFeatures') {
        if (!store.getters['featureToggles/canUseLogFile']) {
          disableLog()
        } else {
          enableLog(store.getters['logger/logConfig'])
        }
      }
    })

    const actionLog = logger.extend('vuex:action')

    // Set of vuex actions to ignore in logging
    const IGNORED_ACTIONS = new Set([
      'systemConnection/setEmqxConnection',
      'systemConnection/setSocketConnection',
      'websocket/newMessage',
    ])

    // Log actions
    store.subscribeAction({
      after: (action) => {
        // Skip logging for ignored actions
        if (IGNORED_ACTIONS.has(action.type)) {
          return
        }
        actionLog(`${action.type}`, action.payload)
        if (action.type === 'setAudienceIdAction') {
          setLogContext({
            audienceId: action.payload,
          })
        } else if (action.type === 'setPresentationAction') {
          setLogContext({
            presentationId: action.payload.id,
          })
        }
      },
    })
  }

export default {
  namespaced: true,
  getters: _getters,
  plugin,
}
